export const TASK_STATUS = {
  INITIATED: 'initiated',
  STARTING: 'starting',
  WAITING: 'waiting',
  RUNNING: 'running',
  PAUSED: 'paused',
  TERMINATED: 'terminated',
  COMPLETED: 'completed',
};
